export const EXPO_VISITOR_ROLE = "EXPO_VISITOR" as const;

export function isExpoVisitorRole(role?: string | null): boolean {
  return role === EXPO_VISITOR_ROLE;
}

/** Company-app JWT roles that use AppLayout (not admin / head / facilitator portals). */
export function isCompanyAppPortalRole(role?: string | null): boolean {
  return role === "CLIENT" || role === "MANAGER" || isExpoVisitorRole(role);
}
